import React from 'react';
import styles from './topPanel.css';
import TimerPanel from './timerPanel/TimerPanel';
import Progress from './progress/Progress';
import CorrectStatus from './correctStatus/CorrectStatus';
import { useSelector } from 'react-redux';

/**
 *
 * @type {React.NamedExoticComponent<{statisticsPopup?: *, calendar?: *, isWithImageTop?: *, setEventSound?: *, contentColor?: *, question?: *, statistics?: *}>}
 */
const TopPanel = React.memo( ( { question, statistics, statisticsPopup, contentColor, setEventSound, isWithImageTop } ) => {
    const { calendar } = useSelector( ( state ) => state );

    const getPanel = () => {

        if ( statistics &&
            statistics.question_statistics &&
            ( statistics.question_statistics.answered_correctly !== null || !statistics.question_statistics.hasOwnProperty( 'answered_correctly' ) ) ) {
            switch (
            statistics &&
            statistics.question_statistics &&
            statistics.question_statistics.answered_correctly ) {
                case true: {
                    return <CorrectStatus setEventSound={ setEventSound } status={ true }/>;
                }
                case false: {
                    return <CorrectStatus setEventSound={ setEventSound } status={ false }/>;
                }
                default:
                    return;
            }
        } else {
            return calendar && calendar.settings.time_limit ?
                <TimerPanel
                    setEventSound={ setEventSound }
                    contentColor={ contentColor }
                    question={ question }
                    statisticsPopup={ statisticsPopup }
                /> : null;
        }
    };

    return (
        <div className={ styles.wrapper }>
            { calendar && calendar.settings.time_limit ? <Progress question={ question }/> : null }
            <div className={ styles.panelWrap } style={ { background: isWithImageTop ? '' : 'rgba(0, 0, 0, 0.8)' } }>
                <div className={ styles.correctWrap }>
                    { getPanel() }
                </div>
            </div>
        </div>
    );
} );

export default TopPanel;
